import React from 'react';
import ReactDOM from 'react-dom/client';
import WebFontProvider from './WebFontProvider';
import App from './App';

const ResponsiveLayout = ({ children }) => {
  return (
    <div className="min-h-screen w-full relative">
      {/* Desktop-only background with blur */}
      <div className="hidden lg:block fixed inset-0 z-[-10000] bg-black">
        <img
          src="assets/thumbnail.png"
          alt="Background"
          className="w-full h-full object-cover opacity-50 blur-xl"
        />
      </div>

      {/* Content container */}
      <div className="relative min-h-screen mx-auto lg:flex lg:items-center lg:justify-center">
        {/* Mobile view container - fixed size on desktop */}
        <div className="w-full lg:w-[390px] lg:h-[844px] min-h-screen lg:min-h-0 lg:rounded-3xl lg:shadow-2xl lg:overflow-hidden">
          {/* Content layer - allows negative z-indices to show */}
          <div className="relative w-full h-full lg:h-[844px] overflow-auto">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <WebFontProvider>
    <ResponsiveLayout>
      <App />
    </ResponsiveLayout>
  </WebFontProvider>
);

export default ResponsiveLayout;